/* Cart drawer delivery estimate: dropdown behaviour and remembered choice.
   The markup is rendered by snippets/delivery-estimate.liquid (market + language aware). */
(function () {
  var KEY = 'alDeliveryCountry';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || null; } catch (e) { return null; }
  }
  function save(market, code) {
    try { localStorage.setItem(KEY, JSON.stringify({ market: market, code: code })); } catch (e) {}
  }

  function select(root, item, persist) {
    var btn = root.querySelector('.dropdown-btn');
    root.querySelectorAll('.dropdown-item').forEach(function (i) {
      i.setAttribute('aria-selected', i === item ? 'true' : 'false');
    });
    btn.querySelector('img').src = item.querySelector('img').src;
    btn.querySelector('.delivery-estimate__label').textContent = item.querySelector('span').textContent;
    var days = root.querySelector('.days');
    if (days) days.textContent = item.dataset.days;
    if (persist) save(root.dataset.market, item.dataset.code);
  }

  function setOpen(root, open) {
    root.querySelector('.dropdown-list').classList.toggle('show', open);
    root.querySelector('.dropdown-btn').setAttribute('aria-expanded', String(open));
  }

  /* Re-apply the visitor's earlier choice after the drawer HTML is (re)rendered.
     Ignored if they have since changed market (country/language switcher). */
  function apply() {
    var saved = read();
    document.querySelectorAll('.delivery-estimate:not([data-ready])').forEach(function (root) {
      root.setAttribute('data-ready', '');
      if (!saved || saved.market !== root.dataset.market || saved.code === root.dataset.default) return;
      var item = root.querySelector('.dropdown-item[data-code="' + saved.code + '"]');
      if (item) select(root, item, false);
    });
  }

  document.addEventListener('click', function (e) {
    var root = e.target.closest && e.target.closest('.delivery-estimate');
    document.querySelectorAll('.delivery-estimate').forEach(function (r) { if (r !== root) setOpen(r, false); });
    if (!root) return;
    var item = e.target.closest('.dropdown-item');
    var btn = e.target.closest('.dropdown-btn');
    if (item) { select(root, item, true); setOpen(root, false); }
    else if (btn) setOpen(root, !root.querySelector('.dropdown-list').classList.contains('show'));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('.delivery-estimate').forEach(function (r) { setOpen(r, false); });
  });

  function init() {
    apply();
    var drawer = document.querySelector('cart-drawer');
    if (drawer) new MutationObserver(apply).observe(drawer, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
